import type { Question } from 'survey-core';

const CHOICE_QUESTION_TYPES = ['radiogroup', 'checkbox', 'dropdown', 'tagbox'];

function resolveDisplayValue(question: Question, value: unknown): unknown {
  if (!CHOICE_QUESTION_TYPES.includes(question.getType().toLowerCase())) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((v) => question.getDisplayValue(false, v));
  }

  return question.getDisplayValue(false, value);
}

interface QuestionProvider {
  getQuestionByName(name: string): Question | null;
}

function resolveDisplayValues(model: QuestionProvider, answers: Record<string, unknown>): Record<string, unknown> {
  const resolved: Record<string, unknown> = { ...answers };

  for (const [key, value] of Object.entries(answers)) {
    const question = model.getQuestionByName(key);
    if (question) {
      resolved[key] = resolveDisplayValue(question, value);
    }
  }

  return resolved;
}

export { CHOICE_QUESTION_TYPES, resolveDisplayValue, resolveDisplayValues };
